/**
 * Tag identifying the message, used to match and refine messages.
 */

/**
 * Messages are used to inform states of new events/data which are of interest,
 * these are passed to `StateUpdate` functions of matching states in the
 * state-hierarchy.
 *
 * Extra data can be assigned on the messages, use the `tag` property to
 * differentiate between different messages.
 */

/**
 * A restricted map of message-key -> subscription-options for a given
 * message-type.
 */

/**
 * Update containing new state-data if any, and any messages to send to
 * supervisors.
 */

/**
 * Initialization function, called when the initial data is loaded into the
 * state.
 */

/**
 * Message representing any other kind of message in the type-signature of
 * `ModelUpdate`, do not match against this message directly.
 *
 * This type exists to ensure users refine the message-type before acting
 * on incoming messages.
 */

/**
 * Update function, receives messages for a state and produces a state-update
 * which can include messages sent to supervisors.
 *
 * The incoming messages can be any random message, refine on `tag` to ensure
 * the messages are indended for the state before acting upon them.
 */

/**
 * Definition of a state containing the data `T` which can be instantiated given
 * the initial data `I`.
 */

/**
 * Utility type resolving the data-type of a model with unspecified
 * type-parameters.
 */

/**
 * Utility type resolving the init-type of a model with unspecified
 * type-parameters.
 */

/**
 * Options for a given subcription, the value true means default values for all
 * options.
 */
var EFFECT_ERROR = "effect/error";
var UPDATE_ERROR = "update/error";
function isMatchingSubscription(subscriptions, _ref) {
  var tag = _ref.tag;
  return Boolean(subscriptions[tag]);
}
function updateNone() {
  return 1;
}
/**
 * Creates an update replacing the data of the state, and if any messages
 * are provided they will be propagated upwards to supervising states and
 * effects.
 */

function updateData(data) {
  for (var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    messages[_key - 1] = arguments[_key];
  }

  return {
    data: data,
    messages: messages
  };
}

export { EFFECT_ERROR, UPDATE_ERROR, isMatchingSubscription, updateData, updateNone };
//# sourceMappingURL=model.js.map
